import firebase from "firebase";

/**
 * verify delivery
 * @param {string} did delivery ID
 */
export default async function verifyDelivery(did) {
  const response =
    (await firebase.functions()
      .httpsCallable('verifyDelivery')({
        did: did,
      })).data;
  return response;
}